<!--
  Copyright 2023 The Ground Authors.

  Licensed under the Apache License, Version 2.0 (the "License");
  you may not use this file except in compliance with the License.
  You may obtain a copy of the License at

      https://www.apache.org/licenses/LICENSE-2.0

  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.
-->

<div class="share-survey-container">
  <mat-card>
    <mat-card-header>
      <mat-card-title i18n="@@app.cards.share.title">People with access</mat-card-title>

      <button class="share-survey-button" mat-flat-button (click)="openShareDialog()">
        <mat-icon>add</mat-icon>

        <span i18n="@@app.labels.addParticipants">Add participants</span>
      </button>
    </mat-card-header>

    <mat-card-content>
      <ground-share-list [survey]="survey()"></ground-share-list>
    </mat-card-content>
  </mat-card>

  <mat-card>
    <mat-card-header>
      <mat-card-title i18n="@@app.cards.generalAccess.title">General access</mat-card-title>
    </mat-card-header>

    <mat-card-content>
      <ground-general-access-control [survey]="survey()"></ground-general-access-control>
    </mat-card-content>
  </mat-card>

  <mat-card>
    <ground-data-visibility-control class="floating-button" [survey]="survey()"></ground-data-visibility-control>

    <mat-card-header>
      <mat-card-title i18n="@@app.cards.dataVisibility.title">Data visibility</mat-card-title>
    </mat-card-header>

    <mat-card-content>
      <div i18n="@@app.cards.dataVisibility.description">Allow data collectors to see each others' data</div>
    </mat-card-content>
  </mat-card>
</div>
